import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  TextField,
  InputAdornment,
  Modal,
  Box,
  Typography,
} from "@mui/material";
import { SearchIcon } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import MyStudentsTable from "./components/MyStudentsTable";
import assets from "../assets/assets";
import axios from "../axios";
import { toast } from "react-toastify";
import { IP } from "../internalServer";

const MyStudents = ({ leftSidebarSize }) => {
  const [classId, setClassId] = useState("");
  const [secionId, setSecionId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [students, setStudents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [classArr, setClassArr] = useState([]);
  const [secArr, setSecArr] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  const schoolId = JSON.parse(localStorage.getItem("schoolId"));

  const jsonRole_CTinformation = useMemo(() => {
    const CTRole_Information = localStorage.getItem("role_as_class_teacher");
    return CTRole_Information ? JSON.parse(CTRole_Information) : [];
  }, []);

  const jsonRole_COOinformation = useMemo(() => {
    const COO_Role_Information = localStorage.getItem("role_as_co_ordinator");
    return COO_Role_Information
      ? JSON.parse(COO_Role_Information)
      : [];
  }, []);

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );

  useEffect(() => {
    let arr1 = [];
    let arr2 = [];

    // ===== CLASS ARRAY =====
    jsonRole_CTinformation.forEach((item) => {
      if (item.is_class_teacher === true) {
        const idExists = arr1.some(
          (obj) => obj.id === item.standard_id.id
        );

        if (!idExists) {
          arr1.push({
            id: item.standard_id.id,
            name: item.standard_id.name,
          });
        }
      }
    });

    jsonRole_COOinformation.forEach((item) => {
      if (item.is_class_co_ordinator === true) {
        const idExists = arr1.some(
          (obj) => obj.id === item.standard_id.id
        );

        if (!idExists) {
          arr1.push({
            id: item.standard_id.id,
            name: item.standard_id.name,
          });
        }
      }
    });

    setClassArr(arr1);

    // ===== SECTION ARRAY =====
    jsonRole_CTinformation.forEach((item) => {
      if (item?.standard_id?.id === classId) {
        const idExists = arr2.some(
          (obj) => obj.id === item.section_id.id
        );

        if (!idExists) {
          arr2.push({
            id: item.section_id.id,
            name: item.section_id.name,
          });
        }
      }
    });

    jsonRole_COOinformation.forEach((item) => {
      if (item?.standard_id?.id === classId) {
        const idExists = arr2.some(
          (obj) => obj.id === item.section_id.id
        );

        if (!idExists) {
          arr2.push({
            id: item.section_id.id,
            name: item.section_id.name,
          });
        }
      }
    });

    setSecArr(arr2);

  }, [classId, jsonRole_CTinformation, jsonRole_COOinformation]);

  const fetchStudents = async () => {
    try {
      const res = await axios.get(
        `/api/v1/school/student/get/school/${schoolId}`
      );
      if (res) {
        setStudents(res.data.data);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log(error);
    }
  };

  const filteredStudentsByClassAndsection =
    students &&
    students.filter(
      (student) =>
        student.standard.id === classId &&
        student.section.id === secionId &&
        student.timetableSession.id === timeTableSessionId
    );

  console.log(
    "filteredStudentsByClassAndsection",
    filteredStudentsByClassAndsection
  );
  const filterBySearch = useMemo(() => {
    return filteredStudentsByClassAndsection.filter((student) =>
      student.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [filteredStudentsByClassAndsection, searchTerm]);

  const paginatedStudents = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    return filterBySearch.slice(start, start + rowsPerPage);
  }, [filterBySearch, currentPage, rowsPerPage]);

  const totalPages = Math.ceil(filterBySearch.length / rowsPerPage);

  const columns = [
    { header: "Adm No", accessor: "admissionNumber" },
    { header: "Student", accessor: "name" },
    { header: "Code", accessor: "code" },
    { header: "Email", accessor: "email" },
    { header: "Mobile Number", accessor: "mobileNumber" },
    { header: "Mother Name", accessor: "motherName" },
    // { header: "Mother Number", accessor: "motherNumber" },
    { header: "Father Name", accessor: "fatherName" },
    // { header: "Father Number", accessor: "fatherNumber" },
    { header: "Subscribed", accessor: "subscribed" },
    { header: "Registered", accessor: "registered" },
    { header: "DOB", accessor: "dateOfBirth" },
  ];

  console.log(paginatedStudents, "paginatedStudents");

  const rows = paginatedStudents.map((student, index) => ({
    ...student,
    id: student.id,
    code: student.code,
    admissionNumber: student.admissionNumber,
    name: student.name,
    email: student.email,
    mobileNumber: student.mobileNumber,
    motherName: student.mother.name,
    motherNumber: student.mother.mobileNumber,
    fatherName: student.father.name,
    fatherNumber: student.father.mobileNumber,
    subscribed: student.isSubscribed === 1 ? "Yes" : "No",
    registered: student.isRegistered ? "Yes" : "No",
    dateOfBirth: new Date(student.dateOfBirth).toLocaleDateString("en-GB"),
    profile_picture: student.profile_picture,
    gender: student.gender,
  }));

  return (
    <div
      className={` orange-scrollBar rounded-3 ${leftSidebarSize === 70 ? "expand" : "collapsess"
        }`}
      style={{
        height: "calc(100vh - 100px)",
        overflow: "auto",
      }}
    >
      <div
        className="p-2 bg-white d-flex align-items-center flex-column gap-2 p-4 "
        style={{ width: "100%" }}
      >
        <div className="d-flex align-items-center  w-100 gap-4">
          {/* Class Dropdown */}
          <FormControl fullWidth size="small" variant="outlined">
            <InputLabel>Class</InputLabel>
            <Select
              value={classId}
              onChange={(e) => {
                setClassId(e.target.value);
                setSecionId("");
              }}
              label="Class"
            >
              {classArr.length > 0 ? (
                [...classArr]
                  .sort((a, b) => {
                    const aNum = Number(a.name);
                    const bNum = Number(b.name);

                    const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                    if (bothNumeric) {
                      return aNum - bNum; // numeric sort
                    }

                    return a.name.localeCompare(b.name); // alphabetical sort
                  })
                  .map((standard, index) => (
                    <MenuItem
                      key={index}
                      value={standard?.id}
                      name={standard?.name}
                    >
                      {standard?.name}
                    </MenuItem>
                  ))
              ) : (
                <MenuItem value={"null"}>No Classes</MenuItem>
              )}
            </Select>
          </FormControl>

          {/* Section Dropdown */}
          <FormControl fullWidth size="small" variant="outlined">
            <InputLabel>Section</InputLabel>
            <Select
              label="Section"
              value={secionId}
              onChange={(e) => setSecionId(e.target.value)}
            >
              {classId && secArr.length > 0 ? (
                secArr.map((item) => (
                  <MenuItem value={item.id}>{item.name}</MenuItem>
                ))
              ) : (
                <MenuItem value={"null"}>No Section </MenuItem>
              )}
            </Select>
          </FormControl>

          {/* Apply Button */}
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "orange",
              color: "white",
              "&:hover": {
                backgroundColor: "#e69500", // darker orange on hover
              },
            }}
            disabled={classId === "" || secionId === ""}
            onClick={() => fetchStudents()}
          >
            Apply
          </Button>
        </div>

        <hr
          className="w-100"
          style={{ height: "1px", backgroundColor: "black" }}
        />

        <div className="mt-2 w-100 d-flex align-items-center flex-column gap-2">
          <div
            className="d-flex align-items-center gap-2 justify-content-between w-100 mx-3"
            style={{ backgroundColor: "" }}
          >
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search by name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ maxWidth: 250 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon style={{ cursor: "pointer" }} size={20} />
                  </InputAdornment>
                ),
              }}
            />

            <div className="d-flex align-items-center gap-2">
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "orange",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#e69500",
                  },
                }}
                onClick={() => setOpenModal(true)}
              >
                Add Notes
              </Button>

              {/* Rows per page */}
              <div className="d-flex align-items-center gap-2">
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  style={{ width: "140px", zIndex: 0 }}
                >
                  <InputLabel>Rows per page</InputLabel>
                  <Select
                    value={rowsPerPage}
                    onChange={(e) => {
                      setRowsPerPage(e.target.value);
                      setCurrentPage(1);
                    }}
                    label="Rows per page"
                  >
                    {[5, 10, 20, 50].map((num) => (
                      <MenuItem key={num} value={num}>
                        {num}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <small className="poppins-semibold">Entries</small>
              </div>
            </div>
          </div>

          <div className="w-100 ">
            <MyStudentsTable
              setSelectedStudents={setSelectedStudents}
              selectedStudents={selectedStudents}
              columns={columns}
              rows={rows}
              leftSidebarSize={leftSidebarSize}
            />
          </div>

          <div className="d-flex align-items-center gap-2 justify-content-end">
            <Box
              display="flex"
              justifyContent="end"
              alignItems="center"
              gap={2}
            >
              <Button
                variant="outlined"
                size="small"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Prev
              </Button>

              <Typography variant="body2">
                Page {currentPage} of {totalPages}
              </Typography>

              <Button
                variant="outlined"
                size="small"
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </Button>
            </Box>
          </div>
        </div>
      </div>

      {/* add notes modal */}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="add-notes-modal"
        aria-describedby="add-notes-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 3,
          }}
        >
          <div
            className="d-flex justify-content-between align-items-center mb-3 py-2 px-2"
            style={{ backgroundColor: "#ffebd3" }}
          >
            <h5 className="mb-0">Add Notes</h5>
            <Button onClick={() => setOpenModal(false)}>
              <img
                src={assets.closeIcon}
                height={20}
                width={20}
                className="object-contain"
                alt="close"
              />
            </Button>
          </div>

          <div className="m-2">
            <TextField
              label="Subject"
              variant="outlined"
              fullWidth
              size="small"
              className="mb-3 "
            />
          </div>

          <div className="m-2">
            <TextField
              label="Add Description"
              variant="outlined"
              fullWidth
              multiline
              rows={3}
              className="mb-3 "
            />
          </div>

          {/* File Upload (placeholder) */}
          <div
            style={{
              border: "2px dashed #ccc",
              borderRadius: "8px",
              textAlign: "center",
              padding: "20px",
              marginBottom: "16px",
            }}
            className="p-2 m-2"
          >
            <p>Drag and drop file here</p>
            <Button variant="contained" size="small" color="warning">
              Browse Files
            </Button>
          </div>

          <div className="d-flex justify-content-end">
            <Button
              variant="contained"
              className="m-2 d-flex align-items-center justify-content-center"
              sx={{
                backgroundColor: "brown",
                color: "white",
                "&:hover": { backgroundColor: "#5a3d2b" },
              }}
              onClick={() => setOpenModal(false)}
            >
              Submit
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default MyStudents;
